import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'INVENTORY',
    icon: 'menu-inventory',
    label: '车辆管理',
    children: [
      {
        code: 'INVENTORY_STOCKTAKING',
        icon: 'menu-inventory-stocktaking',
        label: '库存盘点',
        path: '/inventory/stocktaking',
      },
      {
        code: 'INVENTORY_INBOUND',
        icon: 'menu-inventory-inbound',
        label: '车辆入库',
        path: '/inventory/inbound',
      },
      {
        code: 'INVENTORY_OUTBOUND',
        icon: 'menu-inventory-outbound',
        label: '车辆出库',
        path: '/inventory/outbound',
      },
    ],
  },
] satisfies Menu[];
